import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from './config';
import { capitalizeFirst } from './utils';
import './ViewingAsBanner.css';

function ViewingAsBanner() {
  const [viewingAs, setViewingAs] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCurrentViewingAs();
    // Poll every 30 seconds to check if viewing_as changed
    const interval = setInterval(fetchCurrentViewingAs, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchCurrentViewingAs = async () => {
    try {
      const response = await axios.get(`${API_URL}/portfolio/current-viewing-as/`);
      setViewingAs(response.data.viewing_as);
    } catch (err) {
      console.error('Error fetching current viewing_as:', err);
      setViewingAs(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !viewingAs) {
    return null;
  }

  return (
    <div className="viewing-as-banner">
      <div className="viewing-as-banner-content">
        <span className="viewing-as-banner-icon">⚠️</span>
        <span className="viewing-as-banner-text">
          Je bekijkt de data van <strong>{capitalizeFirst(viewingAs.username)}</strong>
        </span>
      </div>
    </div>
  );
}

export default ViewingAsBanner;

